import { overallReducer } from "../MainLayout/services/slice";

export const rootReducers = {
  overall: overallReducer,
};
